import React from 'react';
import proptypes from 'prop-types';
import { Col, Row } from '@thd-olt-component-react/core-ui';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ReviewSentimentModel } from '../../../models/ReviewSentimentModel';
import { PropTypes as SentimentPropTypes, Sentiment } from './Sentiment';
import { usePresentation } from '../../../../context/PresentationProvider';
import './ReviewSentiments.style.scss';

const { func, string } = proptypes;

export const ReviewSentiments = ({ 
  itemId, 
  onSentimentChange, 
  selectedSentiment = {} 
}) => {
  const { useCondensedLayout } = usePresentation();
  const { data, error, loading } = useDataModel('reviewSentiments', {
    variables: {
      itemId
    },
    ssr: false
  });
  if ((error && !data) || !data || loading) {
    return null;
  }
  const { reviewSentiments } = data;
  const sentimentsModel = new ReviewSentimentModel(reviewSentiments || {});

  if (!sentimentsModel.sentiments.length) {
    return null;
  }
  const { conSentiments, proSentiments } = sentimentsModel;

  return (
    <Row className="ratings-reviews-sentiments">
      <Col xs="6">
        <Sentiment
          name="Pros"
          values={proSentiments}
          selectedSentiment={selectedSentiment}
          onClick={(sentiment) => onSentimentChange(sentiment)}
        />
      </Col>
      <Col xs="6" flatten={useCondensedLayout}>
        <Sentiment
          name="Cons"
          values={conSentiments}
          selectedSentiment={selectedSentiment}
          onClick={(sentiment) => onSentimentChange(sentiment)}
        />
      </Col>
    </Row>
  );

};

ReviewSentiments.displayName = 'ReviewSentiments';

ReviewSentiments.propTypes = {
  itemId: string.isRequired,
  onSentimentChange: func.isRequired,
  selectedSentiment: SentimentPropTypes.selectedSentiment
};
